__turbopack_context__.v({
  "link": "tqsbZq_link",
});
